/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FinishWorkflowRequest
 */
export interface FinishWorkflowRequest {
    /**
     * 
     * @type {boolean}
     * @memberof FinishWorkflowRequest
     */
    generateSignupCompletionToken?: boolean;
}

/**
 * Check if a given object implements the FinishWorkflowRequest interface.
 */
export function instanceOfFinishWorkflowRequest(value: object): value is FinishWorkflowRequest {
    return true;
}

export function FinishWorkflowRequestFromJSON(json: any): FinishWorkflowRequest {
    return FinishWorkflowRequestFromJSONTyped(json, false);
}

export function FinishWorkflowRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): FinishWorkflowRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'generateSignupCompletionToken': json['generateSignupCompletionToken'] == null ? undefined : json['generateSignupCompletionToken'],
    };
}

export function FinishWorkflowRequestToJSON(value?: FinishWorkflowRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'generateSignupCompletionToken': value['generateSignupCompletionToken'],
    };
}

